<template lang="html">
  <div class="placed-backg contact-page-" id="page-info-t1">
    <div class="bg-image" v-bind:style="{ backgroundImage: 'url(public/images/pages/contact/bg.jpg)' }"></div>

    <section class="container oversized-container content-section">
      <div class="row align-items-center justify-content-center">
        <div class="col-lg-4 text-center col-info">
          <h1 class="mb-2 page-title">Contacto</h1>

          <h6 class="f-w-700">Dirección</h6>
          <p v-html="$root.contactInfo.address"></p>

          <br />
          <h6 class="f-w-700">Teléfonos de oficina</h6>
          <p v-html="$root.contactInfo.telefono"></p>

          <br />
          <h6 class="f-w-700">Horario de atención</h6>
          <p v-html="$root.contactInfo.schedule"></p>

          <br />
          <h6 class="f-w-700">Siguenos en redes sociales</h6>
          <p>
            <a class="btn-social fb" target="_blank" v-if="$root.contactInfo.facebook" :href="$root.contactInfo.facebook"><i class="fa-brands fa-square-facebook"></i></a>
            <!-- <a class="btn-social" href=""><i class="fa-brands fa-x-twitter"></i></a> -->
            <a class="btn-social" target="_blank" v-if="$root.contactInfo.instagram" :href="$root.contactInfo.instagram"><i class="fab fa-instagram"></i></a>
            <a class="btn-social" target="_blank" v-if="$root.contactInfo.youtube" :href="$root.contactInfo.youtube"><i class="fa-brands fa-youtube"></i></a>
            <!-- <a class="btn-social tt" href=""><i class="fa-brands fa-tiktok"></i></a> -->
          </p>
        </div>

        <div class="col-lg-5 col-xl-4 col-info">
          <b-form @submit="onSubmit">
            <b-form-group>
              <b-form-input
                v-model="form.name"
                type="text"
                required
                placeholder="Nombre de contacto"
              ></b-form-input>
            </b-form-group>

            <b-form-group>
              <b-form-input
                v-model="form.email"
                type="email"
                required
                placeholder="Correo de empresa"
              ></b-form-input>
            </b-form-group>

            <b-form-group>
              <b-form-input
                v-model="form.phone"
                type="text"
                required
                placeholder="Teléfono"
              ></b-form-input>
            </b-form-group>

            <b-form-group>
              <b-form-input
                v-model="form.subject"
                type="text"
                required
                placeholder="Asunto"
              ></b-form-input>
            </b-form-group>

            <b-form-group>
              <b-form-input
                v-model="form.company"
                type="text"
                required
                placeholder="Nombre de la empresa"
              ></b-form-input>
            </b-form-group>

            <b-form-group>
              <b-form-textarea
                v-model="form.msg"
                placeholder="Escriba su mensaje"
                required
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>

            <p class="text-center">
              <b-button type="submit" class="btn-send">Enviar</b-button>
            </p>
          </b-form>

        </div>
      </div>
    </section>

    <section class="container-fluid px-0 map-section">
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3764.1786857918946!2d-99.11308732575739!3d19.36141414295232!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1fe0d0f1d52db%3A0xdca96450c5e96b11!2sAv.%205%20138%2C%20Escuadr%C3%B3n%20201%2C%20Iztapalapa%2C%2009060%20Ciudad%20de%20M%C3%A9xico%2C%20CDMX!5e0!3m2!1ses-419!2smx!4v1744840616574!5m2!1ses-419!2smx" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </section>
  </div>
</template>

<script>
export default {
  data(){
    return{
      form: {
        name: null,
        email: null,
        phone: null,
        subject: null,
        company: null,
        msg: null
      },
      info: {
        contact:null,
      },
    }
  },

  methods: {
    makeToast(variant = null, msg, title) {
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        solid: true,
        toaster: 'b-toaster-top-right',
        appendToast: true
      })
    },

    getInfo: function(){
      axios.get(tools.url('/api/info')).then((response)=>{
        this.info = response.data;
      }).catch((error)=>{
        console.log(error);
      })
    },

    onSubmit(evt) {
      evt.preventDefault();
      //var data=tools.params(form, this.form);
      axios.post(tools.url("/api/contact"), this.form).then((response)=>{
          this.makeToast('default', response.data.response, 'Mensaje enviado');
          this.form = {
            name: null,
            email: null,
            msg: null,
            check: null
          };
        }).catch( (error)=> {
        // console.log(error.response);
        let errors = error.response.data;
        // console.log(errors);
        this.makeToast('danger', error.response.data.name, 'Error');
        this.makeToast('danger', error.response.data.email, 'Error');
        this.makeToast('danger', error.response.data.phone, 'Error');
        this.makeToast('danger', error.response.data.msg, 'Error');
      });
    }
  },

  beforeMount(){
    // this.getInfo();

    if(this.$route.query.p){
      this.form.msg = 'Me intresa el producto '+ this.$route.query.p;
    }
  }
}
</script>
